import {modals} from "@mantine/modals";
import {ILinkCategory} from "@/types/models/ILinkCategory.ts";
import EditLinkCategoryModal from "@/components/SidebarLinks/EditLinkCategoryModal/modal.tsx";

export const EDIT_LINK_CATEGORY_MODAL_ID = "editLinkCategoryModal"

export function openEditLinkCategoryModal(category: ILinkCategory, onComplete: () => void) {
    modals.open({
        modalId: EDIT_LINK_CATEGORY_MODAL_ID,
        title: "Edit Link Category",
        children: <EditLinkCategoryModal category={category} onComplete={onComplete}/>
    })
}